"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.owMsgBurnNFTOptions = exports.owMsgTransferNFTOptions = exports.owMsgEditNFTOptions = exports.owMsgMintNFTOptions = exports.owMsgIssueDenomOptions = exports.owMsgBeginRedelgateOptions = exports.owMsgWithdrawValidatorCommissionOptions = exports.owMsgUndelegateOptions = exports.owMsgDelegateOptions = exports.owMsgFundCommunityPoolOptions = exports.owMsgSetWithdrawAddressOptions = exports.owMsgWithdrawDelegatorRewardOptions = exports.owMsgEditValidatorOptions = exports.owMsgCreateValidatorOptions = exports.owMsgVoteOptions = exports.owMsgDepositOptions = exports.owMsgSubmitProposalOptions = exports.owMsgSendOptions = exports.owVoteOption = void 0;
var ow_1 = __importDefault(require("ow"));
var ow_types_1 = require("../../coin/ow.types");
var ow_types_2 = require("../../ow.types");
var MsgVote_1 = require("./gov/MsgVote");
var IMsgProposalContent_1 = require("./gov/IMsgProposalContent");
var voteOptionValidator = function (val) { return ({
    validator: Object.values(MsgVote_1.VoteOption).includes(val),
    message: function (label) { return "Expected " + label + " to be one of the Vote options, got `" + val + "`"; },
}); };
exports.owVoteOption = function () { return ow_1.default.number.validate(voteOptionValidator); };
exports.owMsgSendOptions = ow_types_2.owStrictObject().exactShape({
    fromAddress: ow_1.default.string,
    toAddress: ow_1.default.string,
    amount: ow_types_1.owCoin(),
});
var proposalContentValidatorFn = function (val) { return ({
    validator: IMsgProposalContent_1.isMsgProposalContent(val),
    message: function (label) { return "Expected " + label + " to be an instance of `IMsgProposalContent`, got `" + val + "`"; },
}); };
var owContent = function () { return ow_types_2.owStrictObject().validate(proposalContentValidatorFn); };
exports.owMsgSubmitProposalOptions = ow_types_2.owStrictObject().exactShape({
    proposer: ow_1.default.string,
    initialDeposit: ow_types_1.owCoin(),
    content: owContent(),
});
exports.owMsgDepositOptions = ow_types_2.owStrictObject().exactShape({
    depositor: ow_1.default.string,
    proposalId: ow_types_2.owBig(),
    amount: ow_types_1.owCoin(),
});
exports.owMsgVoteOptions = ow_types_2.owStrictObject().exactShape({
    voter: ow_1.default.string,
    proposalId: ow_types_2.owBig(),
    option: exports.owVoteOption(),
});
exports.owMsgCreateValidatorOptions = ow_types_2.owStrictObject().exactShape({
    description: {
        moniker: ow_1.default.string,
        identity: ow_1.default.optional.string,
        website: ow_1.default.optional.string,
        securityContact: ow_1.default.optional.string,
        details: ow_1.default.optional.string,
    },
    commission: {
        rate: ow_1.default.string,
        maxRate: ow_1.default.string,
        maxChangeRate: ow_1.default.string,
    },
    minSelfDelegation: ow_1.default.string,
    delegatorAddress: ow_1.default.string,
    validatorAddress: ow_1.default.string,
    pubkey: ow_1.default.string,
    value: ow_types_1.owCoin(),
});
exports.owMsgEditValidatorOptions = ow_types_2.owStrictObject().exactShape({
    description: {
        moniker: ow_1.default.optional.string,
        identity: ow_1.default.optional.string,
        website: ow_1.default.optional.string,
        securityContact: ow_1.default.optional.string,
        details: ow_1.default.optional.string,
    },
    validatorAddress: ow_1.default.string,
    commissionRate: ow_1.default.any(ow_1.default.string, ow_1.default.null),
    minSelfDelegation: ow_1.default.any(ow_1.default.string, ow_1.default.null),
});
exports.owMsgWithdrawDelegatorRewardOptions = ow_types_2.owStrictObject().exactShape({
    delegatorAddress: ow_1.default.string,
    validatorAddress: ow_1.default.string,
});
exports.owMsgSetWithdrawAddressOptions = ow_types_2.owStrictObject().exactShape({
    delegatorAddress: ow_1.default.string,
    withdrawAddress: ow_1.default.string,
});
exports.owMsgFundCommunityPoolOptions = ow_types_2.owStrictObject().exactShape({
    depositor: ow_1.default.string,
    amount: ow_types_1.owCoin(),
});
exports.owMsgDelegateOptions = ow_types_2.owStrictObject().exactShape({
    delegatorAddress: ow_1.default.string,
    validatorAddress: ow_1.default.string,
    amount: ow_types_1.owCoin(),
});
exports.owMsgUndelegateOptions = ow_types_2.owStrictObject().exactShape({
    delegatorAddress: ow_1.default.string,
    validatorAddress: ow_1.default.string,
    amount: ow_types_1.owCoin(),
});
exports.owMsgWithdrawValidatorCommissionOptions = ow_types_2.owStrictObject().exactShape({
    validatorAddress: ow_1.default.string,
});
exports.owMsgBeginRedelgateOptions = ow_types_2.owStrictObject().exactShape({
    delegatorAddress: ow_1.default.string,
    validatorDstAddress: ow_1.default.string,
    validatorSrcAddress: ow_1.default.string,
    amount: ow_types_1.owCoin(),
});
var owNFTStartWithAlphabetValidatorFn = function (val) { return ({
    validator: /^[a-z]/.test(val),
    message: function (label) { return "Expected " + label + " to start with lowercase alphabets"; },
}); };
var owNFTIsAlphaNumericValidatorFn = function (val) { return ({
    validator: /^[a-z0-9]+$/.test(val),
    message: function (label) { return "Expected " + label + " to contain only lowercase alphanumeric characters"; },
}); };
var owNFTId = ow_1.default.string
    .minLength(3)
    .maxLength(64)
    .validate(owNFTStartWithAlphabetValidatorFn)
    .validate(owNFTIsAlphaNumericValidatorFn);
var owNFTNameValidator = function (val) { return ({
    validator: val.replace(/\s/g, '').length > 0,
    message: function (label) { return "Expected " + label + " to be non-empty string"; },
}); };
var URI_MAX_LENGTH = 256;
exports.owMsgIssueDenomOptions = ow_types_2.owStrictObject().exactShape({
    id: owNFTId,
    name: ow_1.default.string.validate(owNFTNameValidator),
    schema: ow_1.default.string,
    sender: ow_1.default.string,
});
exports.owMsgMintNFTOptions = ow_types_2.owStrictObject().exactShape({
    id: owNFTId,
    denomId: owNFTId,
    name: ow_1.default.string.validate(owNFTNameValidator),
    uri: ow_1.default.string.maxLength(URI_MAX_LENGTH),
    data: ow_1.default.string,
    sender: ow_1.default.string,
    recipient: ow_1.default.string,
});
exports.owMsgEditNFTOptions = ow_types_2.owStrictObject().exactShape({
    id: owNFTId,
    denomId: owNFTId,
    name: ow_1.default.string.validate(owNFTNameValidator),
    uri: ow_1.default.string.maxLength(URI_MAX_LENGTH),
    data: ow_1.default.string,
    sender: ow_1.default.string,
});
exports.owMsgTransferNFTOptions = ow_types_2.owStrictObject().exactShape({
    id: owNFTId,
    denomId: owNFTId,
    sender: ow_1.default.string,
    recipient: ow_1.default.string,
});
exports.owMsgBurnNFTOptions = ow_types_2.owStrictObject().exactShape({
    id: owNFTId,
    denomId: owNFTId,
    sender: ow_1.default.string,
});
//# sourceMappingURL=ow.types.js.map